// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Faq from '../_raw/ui/icon_faq.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Faq);
